import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'

export const BlogDetailsStyle = {
    '.blog-container': {
        maxWidth: pxToRem(1140),
        margin: '0 auto',
        padding: `0 ${pxToRem(15)}`,
        '.blog-name': {
            margin: `${pxToRem(25)} 0`
        },
        h2: {
            fontWeight: 700
        }
    },

    '.blog-content-asset': {
        p: {
            fontSize: pxToRem(16),
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: pxToRem(1.28),
            margin: `${pxToRem(16)} 0`,
            color: 'cav_light_black',
            fontFamily: fonts.primary
        },
        h1: {
            fontSize: pxToRem(21),
            marginBottom: pxToRem(14),
            fontWeight: 400,
            fontFamily: fonts.primary,
            [`@media (max-width: ${sizes.container.md})`]: {
                fontSize: pxToRem(24),
                margin: `${pxToRem(10)} 0`
            }
        },
        h2: {
            textTransform: 'uppercase',
            fontSize: pxToRem(16),
            color: 'cav_light_black',
            fontFamily: fonts.primary,
            [`@media (max-width: ${sizes.container.md})`]: {
                fontSize: pxToRem(24),
                lineHeight: pxToRem(30)
            }
        },
        h3: {
            fontSize: pxToRem(30),
            margin: '1.5rem 0',
            textAlign: 'center',
            fontFamily: fonts.primary,
            letterSpacing: pxToRem(1),
            fontWeight: 700
        },

        a: {
            overflow: 'hidden',
            background: 'transparent',
            color: 'cav_red',
            outline: 'medium none',
            fontSize: pxToRem(16),
            lineHeight: 'auto',
            latterSpacing: pxToRem(1),
            textDecoration: 'none',
            margin: 'auto'
        },
        'a:hover': {
            textDecoration: 'none'
        },
        'ul li': {
            listStyle: 'square outside none',
            lineHeight: pxToRem(24)
        },
        'ol li': {
            listStyle: 'decimal outside none',
            lineHeight: pxToRem(24)
        },
        hr: {
            boxSizing: 'content-box',
            height: 0,
            borderWidth: pxToRem(1),
            opacity: '.5'
        }
    }
}
